import {
    Subject,
    Observable
} from 'rxjs';

export class ToastRef<T> {
    instance: T;

    _afterCloseSbj: Subject<any> = new Subject();
    afterClose$: Observable<any> = this._afterCloseSbj.asObservable();

    _closeSbj: Subject<any> = new Subject();
    close$: Observable<any> = this._closeSbj.asObservable();

    constructor() {
    }

    afterClose(): Observable<any> {
        return this.afterClose$;
    }

    close(value: any = null) {
        this._closeSbj.next();
        this._closeSbj.complete();
        this._afterCloseSbj.next(value);
        this._afterCloseSbj.complete();
    }
}
